import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';

async function putVisitaFiliadoDisp(visitaFiliadoDisp) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.put('/visita-filiado-disp', visitaFiliadoDisp);
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}



export {putVisitaFiliadoDisp};
